import { Injectable } from '@angular/core';
import { ScheduleResponse } from '@shared/models/campaignsInterfaces.model';
import { StatsPerScenario } from '@shared/models/statsPerScenario.model';
import { Observable, Subject } from 'rxjs';
import { CampaignsDal } from '../dal/campaigns.dal';

@Injectable({
  providedIn: 'root',
})
export class CampaignsService {
  public campaignToggle: Subject<boolean> = new Subject<boolean>();

  constructor(private campaignsDal: CampaignsDal) {}

  getCampaigns(
    page: number | null,
    limit: number | null,
    accessOptionPositions: string,
    fromAccount?: boolean
  ): Observable<any> {
    return this.campaignsDal.getCampaigns(page, limit, accessOptionPositions, fromAccount);
  }

  getAllCampaigns(): Observable<any> {
    return this.campaignsDal.getAllCampaigns();
  }

  generateExcelReport(campaignId: string, scenarioId: string, isNotCampaign?: boolean): Observable<ScheduleResponse> {
    return this.campaignsDal.generateExcelReport(campaignId, scenarioId, isNotCampaign);
  }

  exportScenario(campaignId: string, scenarioId: string): Observable<any> {
    return this.campaignsDal.exportScenario(campaignId, scenarioId);
  }

  getAllCampaignRequests(campaignId: string, scenarioId: string, fromDate: string, toDate: string): Observable<any> {
    return this.campaignsDal.getAllCampaignRequests(campaignId, scenarioId, fromDate, toDate);
  }

  getCampaignRequests(
    page: number,
    limit: number,
    campaignId: string,
    profile?: string,
    onHold?: boolean,
    searchValue?: string,
    isNight?: boolean
  ): Observable<any> {
    return this.campaignsDal.getCampaignRequests(page, limit, campaignId, profile, onHold, searchValue, isNight);
  }

  getCampaignConstraints(
    page: number,
    limit: number,
    campaignId: string,
    constraintType: string,
    searchValue?: string
  ): Observable<any> {
    return this.campaignsDal.getCampaignConstraints(page, limit, campaignId, constraintType, searchValue);
  }

  getCampaignNeeds(
    page: number,
    limit: number,
    campaignId: string,
    searchValue?: string,
    needsAnesthMode?: string,
    needType?: string
  ): Observable<any> {
    return this.campaignsDal.getCampaignNeeds(page, limit, campaignId, searchValue, needsAnesthMode, needType);
  }

  checkCreate(
    fromDate: string,
    toDate: string,
    position: string,
    campaignPositions: string[],
    campaignId?: string,
    campaignPeriods?: string
  ): Observable<any> {
    return this.campaignsDal.checkCreate(fromDate, toDate, position, campaignPositions, campaignId, campaignPeriods);
  }

  generatePlanning(campaignId: string): Observable<any> {
    return this.campaignsDal.generatePlanning(campaignId);
  }

  generateCampaignRequests(campaignId: string): Observable<any> {
    return this.campaignsDal.generateCampaignRequests(campaignId);
  }

  addCampaign(body: {
    name: string;
    openingDate: string;
    closingDate: string;
    fromDate: string;
    toDate: string;
    numberOfRequestPerPersons: number;
    positions: string[];
    status?: string;
    hospital: string;
  }): Observable<any> {
    return this.campaignsDal.addCampaign(body);
  }

  addCampaignRequest(body: {
    date: string;
    requestCampaign: string;
    hospital: string;
    availability: string;
    reason?: string;
    profile?: string;
    reasonMaps: string[];
    period: string;
  }): Observable<any> {
    return this.campaignsDal.addCampaignRequest(body);
  }

  modifyCampaign(id: string, body: any): Observable<any> {
    return this.campaignsDal.modifyCampaign(id, body);
  }

  deleteCampaign(id: string): Observable<any> {
    return this.campaignsDal.deleteCampaign(id);
  }

  deleteCampaignRequest(id: string): Observable<any> {
    return this.campaignsDal.deleteCampaignRequest(id);
  }

  clear() {
    this.campaignToggle.complete();
    this.campaignToggle = new Subject<boolean>();
  }

  getCampaignScenarios(campaignId: string, isAdjustment?: boolean): Observable<StatsPerScenario[]> {
    return this.campaignsDal.getCampaignScenarios(campaignId, isAdjustment);
  }

  getScenarios(hospital: string): Observable<any> {
    return this.campaignsDal.getScenarios(hospital);
  }

  checkPrerequisites(campaignId: string): Observable<any> {
    return this.campaignsDal.checkPrerequisites(campaignId);
  }

  getCampaign(campaignId: string): Observable<any> {
    return this.campaignsDal.getCampaign(campaignId);
  }

  getUnmetCampaignNeeds(campaignId: string, scenario: string): Observable<any> {
    return this.campaignsDal.getUnmetCampaignNeeds(campaignId, scenario);
  }
}
